export const ECOSISTEMA_LOADING = 'ECOSISTEMA_LOADING';
export const ECOSISTEMA_LOADED = 'ECOSISTEMA_LOADED';
export const ECOSISTEMA_ERROR = 'ECOSISTEMA_ERROR';